<template>
  <div>
    <div v-if="showdietmodal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container modal-width500" style=" max-width: 500px;">
              <div class="modal-body p-0">
                <div v-if="loaderspinner" class="appointmentlist-spinner">
                  <div class="processing_popup full-spinner"
                    style="visibility: visible; height: 100%; z-index:9999999999;">
                    <div class="spinner cover-spin">
                      <div class="bounce1"></div>
                      <div class="bounce2"></div>
                      <div class="bounce3"></div>
                    </div>
                  </div>
                </div>
                <div class="pb-3 pr-3 pl-3">
                  <div class="col-md-12 px-0">
                    <div class="close-sec-hold" style="right: -15px; top: -15px;">
                      <button type="button" data-dismiss="modal" @click="$emit('cancelAction')" class="close d-close">
                        <i class="material-icons">close</i>
                      </button>
                    </div>
                    <h5 class="text-center mt-3 mb-3 m-0">Diet</h5>
                    <div class="diethistory-popup">


                      <slot name="body">
                        <!-- {{viewdietdata}} -->
                        <div v-if="viewdietdata && viewdietdata.length > 0">
                          <div v-for="(i, j) in viewdietdata" :key="j">
                            <div id="invest-body" width="100%">
                              <table width="100%" class="no-border" border="0" cellpadding="0" cellspacing="0"
                                bgcolor="#FFFFFF" style="margin-left: auto; margin-right: auto; margin-bottom:15px;">
                                <tr style="display: none">
                                  <td align="left" valign="top" bgcolor="#0057df"
                                    style="width:100%; padding:10px 0 10px 10px; " class="wrapper">
                                    <span class="body-text"
                                      style="font-family:'Poppins', sans-serif; color: #FFF;  font-size: 17px; line-height:140%;">
                                      <span style="font-weight:400; font-size: 17px;">Diet</span><span
                                        style="font-weight:400; font-size: 17px; float:right">{{
                                        viewdietdata[j].modifiedOn }}</span>
                                    </span>
                                  </td>
                                </tr>
                                <tr v-if="viewdietdata[j].foodsOnGettingUp.length > 0">
                                  <td valign="top" align="left" style="padding: 0px 0px 14px 0px;">
                                    <h5
                                      style="font-size: 16px; font-weight: 500;margin:0;font-family: 'Poppins', sans-serif;">
                                      On Getting Up</h5>
                                  </td>
                                </tr>
                                <tr v-if="viewdietdata[j].foodsOnGettingUp.length > 0">
                                  <td valign="top" align="left" style="border-bottom: 1px solid #eeeeee;">
                                    <table class="responsive b-table table invoice-print" border="0" cellpadding="0"
                                      cellspacing="0" style="margin-bottom:15px; width:100%;">
                                      <thead
                                        style="background: #dddddd;    color: #333333;  width:100%;  font-weight: 400;    ">
                                        <tr>
                                          <th valign="middle" align="left"
                                            style="width:30px; font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            <span>S.No</span>
                                          </th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            Item</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            PortIon Size</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;width:120px;font-family: 'Poppins', sans-serif;">
                                            Calories</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            Notes</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(item, index) in viewdietdata[j].foodsOnGettingUp" :key="index">
                                          <td
                                            style="padding:0.75rem;font-size:14px;text-align:center;font-family: 'Poppins', sans-serif;">
                                            {{ index + 1 }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.name }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.portionSize + ' ' + item.portionUOM }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.caloriesInOneUnit * item.portionSize }} Cal</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.description }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr v-if="viewdietdata[j].foodsPreBreakfast.length > 0">
                                  <td valign="top" align="left" style="padding: 0px 0px 14px 0px;">
                                    <h5
                                      style="font-size: 16px; font-weight: 500;margin:0;font-family: 'Poppins', sans-serif;">
                                      Pre Breakfast</h5>
                                  </td>
                                </tr>
                                <tr v-if="viewdietdata[j].foodsPreBreakfast.length > 0">
                                  <td valign="top" align="left" style="border-bottom: 1px solid #eeeeee;">
                                    <table class="responsive b-table table invoice-print" border="0" cellpadding="0"
                                      cellspacing="0" style="margin-bottom:15px; width:100%;">
                                      <thead
                                        style="background: #dddddd;    color: #333333;  width:100%;  font-weight: 400;    ">
                                        <tr>
                                          <th valign="middle" align="left"
                                            style="width:30px; font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            <span>S.No</span>
                                          </th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            Item</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            PortIon Size</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;width:120px;font-family: 'Poppins', sans-serif;">
                                            Calories</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            Notes</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(item, index) in viewdietdata[j].foodsPreBreakfast" :key="index">
                                          <td
                                            style="padding:0.75rem;font-size:14px;text-align:center;font-family: 'Poppins', sans-serif;">
                                            {{ index + 1 }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.name }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.portionSize + ' ' + item.portionUOM }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.caloriesInOneUnit * item.portionSize }} Cal</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.description }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr v-if="viewdietdata[j].foodsBreakfast.length > 0">
                                  <td valign="top" align="left" style="padding: 0px 0px 14px 0px;;">
                                    <h5
                                      style="font-size: 16px; font-weight: 500;margin:0;font-family: 'Poppins', sans-serif;">
                                      Breakfast</h5>
                                  </td>
                                </tr>
                                <tr v-if="viewdietdata[j].foodsBreakfast.length > 0">
                                  <td valign="top" align="left" style="border-bottom: 1px solid #eeeeee;">
                                    <table class="responsive b-table table invoice-print" border="0" cellpadding="0"
                                      cellspacing="0" style="margin-bottom:15px; width:100%;">
                                      <thead
                                        style="background: #dddddd;    color: #333333;  width:100%;  font-weight: 400;    ">
                                        <tr>
                                          <th valign="middle" align="left"
                                            style="width:30px; font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            <span>S.No</span>
                                          </th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            Item</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            PortIon Size</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;width:120px;font-family: 'Poppins', sans-serif;">
                                            Calories</th>
                                          <th valign="middle" align="left"
                                            style="font-weight: 400;padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            Notes</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(item, index) in viewdietdata[j].foodsBreakfast" :key="index">
                                          <td
                                            style="padding:0.75rem;font-size:14px;text-align:center;font-family: 'Poppins', sans-serif;">
                                            {{ index + 1 }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.name }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.portionSize + ' ' + item.portionUOM }}</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.caloriesInOneUnit * item.portionSize }} Cal</td>
                                          <td
                                            style="padding:0.75rem;font-size:14px;font-family: 'Poppins', sans-serif;">
                                            {{ item.description }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div v-else-if="!loaderspinner" class="pt-4">
                          No diet data has been added yet.
                        </div>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["showdietmodal", "viewdietdata"],
  data() {
    return {
      loaderspinner: false,
      //viewdietdata:null,
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;

}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}



/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-container.modal-width500 {
  max-width: 750px;
  width: 750px;
  padding: 10px;
}

.modal-container.modal-width500 .modal-header {
  border-bottom: 1px solid transparent !important;
  padding-bottom: 0px !important;
}

.modal-container.modal-width500 .modal-footer {
  border-top: 1px solid transparent !important;
}

.modal-container.modal-width500 .modal-header {
  min-height: 10px !important;
}

.modal-container.modal-width500 .modal-body {
  margin: 0px !important;
}

.sec-div-line {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.container-list:last-child .sec-div-line {
  border: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}
.diethistory-popup {
    max-height: 400px;
    overflow: auto;
    padding-right: 10px;
}
</style>